<template>
  <svg
    id="Laag_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1275 850"
    style="enable-background: new 0 0 1275 850"
    xml:space="preserve"
  >
    <rect class="st0" fill="#000000" />
    <path
      class="st1"
      d="M443.5,398.7c0,45.9-37.2,83.2-83.2,83.2c-45.9,0-83.2-37.2-83.2-83.2s37.2-83.2,83.2-83.2  C406.3,315.5,443.5,352.7,443.5,398.7"
      fill="#000000"
    />
    <path
      class="st1"
      d="M443.5,583.4c0-45.9-37.2-83.2-83.2-83.2c-45.9,0-83.2,37.2-83.2,83.2c0,1.1,0,2.2,0.1,3.3h-0.1V722h166.3  V586.7h-0.1C443.4,585.6,443.5,584.5,443.5,583.4z"
      fill="#000000"
    />
    <path
      class="st2"
      d="M960.9,398.7c0,45.9-37.2,83.2-83.2,83.2c-45.9,0-83.2-37.2-83.2-83.2s37.2-83.2,83.2-83.2  C923.6,315.5,960.9,352.7,960.9,398.7"
      fill="#000000"
    />
    <path
      class="st2"
      d="M960.9,583.4c0-45.9-37.2-83.2-83.2-83.2c-45.9,0-83.2,37.2-83.2,83.2c0,1.1,0,2.2,0.1,3.3h-0.1V722h166.3  V586.7h-0.1C960.8,585.6,960.9,584.5,960.9,583.4z"
      fill="#000000"
    />
    <path
      class="st3"
      d="M739.1,287.8c0,66.3-53.8,120.1-120.1,120.1c-66.3,0-120.1-53.8-120.1-120.1c0-66.3,53.8-120.1,120.1-120.1  C685.4,167.7,739.1,221.4,739.1,287.8"
      fill="#000000"
    />
    <path
      class="st3"
      d="M619,444.8c-66.3,0-120.1,53.8-120.1,120.1v212.5h240.2V565C739.1,498.6,685.4,444.8,619,444.8z"
      fill="#000000"
    />
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "ThreePeopleIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
<style type="text/css">
.st0 {
  fill: none;
}
.st1 {
  fill: #fe5866;
}
.st2 {
  fill: #2175d9;
}
.st3 {
  fill: #ffb511;
}
</style>
